import NullComponent from "../components/questions/null-component-question.js"
class Item {
  /**
   * @param {import("../shared-types").ItemJSON} item
   */
  constructor(item) {
    this.data = item.data;
    this.attributes = this.data.attributes;
    this.id = this.data.id;
    this.body = this.attributes.body;
    /** @type{string|undefined} */
    this.bodyWithSubstitutions = undefined
    this.included = item.included;
  }

  /**
   * @param {string} mode
   * @returns {import("preact").ComponentClass | import("preact").FunctionComponent}
   */
  component(mode) {
    return NullComponent;
  }
}

export default Item;